module.exports = __webpack_public_path__ + "media/new-message.730f691e.wav";